var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tabs',[_c('TabPane',{attrs:{"label":"注册用户","icon":"ios-person-add"}},[_c('signup-mumber',{on:{"refresh":_vm.refresh}})],1),_c('TabPane',{attrs:{"label":"直接添加","icon":"ios-add-circle"}},[_c('plus-mumber',{on:{"refresh":_vm.refresh}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }